import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Slider,
} from "@mui/material";
import { linkUploader_bg_color } from "../../../../constants/colors";
import Link_Icon from "../../../../assets/Link_Icon.png";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";

const MusicSettings = () => {
  // const [value, setValue] = useState(0.50);
  const [inputValue, setInputValue] = useState("1.00");
  const [theme, setTheme] = useState(localStorage.getItem("theme"));

  const {genVideoVoiceVolume, setGenVideoVoiceVolume} = useWorkspace()


  const handleSliderChange = (event, newValue) => {
    setGenVideoVoiceVolume(newValue);
    setInputValue(newValue.toFixed(2));  // Sync TextField with slider
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update text input without validation
  };

  const handleInputBlur = () => {
    // Validate and update slider value on blur
    const inputFloat = parseFloat(inputValue);
    if (!isNaN(inputFloat) && inputFloat >= 0.01 && inputFloat <= 1.00) {
      setGenVideoVoiceVolume(inputFloat);
    } else {
      setInputValue(genVideoVoiceVolume.toFixed(2)); // Reset to slider value if invalid
    }
  };

 

  //   const handleInputChange = (event) => {parseFloat(event.target.value);
  //   if (event.target.value >= 0.99 && event.target.value <= 1.00) {
  //     setValue(event.target.value);
  //   }
  // };

  // const handleInputChange = (event) => {
  //   const inputValue = parseFloat(event.target.value);
  //   if (!isNaN(inputValue) && inputValue >= 0.01 && inputValue <= 1.00) {
  //     setValue(inputValue);
  //   }
  // };

  return (
    <>
      <Box sx={{ padding: "0px 0px" }}>
        <Box sx={{ pt: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "16px",
              fontWeight: "500",
              height: "20px",
              marginBottom: "20px",
            }}
          >
            Video Background Music Settings
          </Typography>
          </Box>

        <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "24px",
        gap: "50px",
      }}
    >
      <Typography sx={{ flexShrink: 0 }}>Music Volume</Typography>
      <Slider
        value={genVideoVoiceVolume}
        onChange={handleSliderChange}
        min={0.01}
        max={1.00}
        step={0.01}
        aria-label="Music Volume"
        valueLabelDisplay="auto"
        sx={{
          color: "white", // This sets the color for the active (left) track and thumb
          "& .MuiSlider-thumb": {
            backgroundColor: "white", // Thumb color to white
            border: "2px solid white", // Optional border for better visibility
          },
          "& .MuiSlider-track": {
            backgroundColor: "white", // Left side of the slider track
          },
          "& .MuiSlider-rail": {
            backgroundColor: "gray", // Right side of the slider track
          },
        }}
      />
      <TextField
        variant="outlined"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur} // Validate on blur
        inputProps={{
          step: 0.01,
          min: 0.01,
          max: 1.00,
          type: 'number',
        }}
        sx={{ width: 200, marginRight:"24px",
          "& .MuiInputBase-input": {
            color: "#ffffff", // Set input text color to white
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "gray", // Default border color
            },
            "&:hover fieldset": {
              borderColor: "white", // Hover border color
            },
            "&.Mui-focused fieldset": {
              borderColor: "white", // Focused border color
            },
          },
         }}
      />
    </div>
      </Box>
      
    </>
  );
};

export default MusicSettings;
